import { CanonicalLoad } from '@numeo/types-core'

type LoadCoordinateKey = 'pickupLat' | 'pickupLon' | 'deliveryLat' | 'deliveryLon'
type NormalizedLoadCoordinates = Pick<CanonicalLoad, LoadCoordinateKey>

const toFiniteNumberOrNull = (value: unknown): number | null => {
    if (value === null || value === undefined || (typeof value === 'string' && value.trim() === '')) return null
    const parsed = typeof value === 'number' || typeof value === 'string' ? Number(value) : Number.NaN
    return Number.isFinite(parsed) ? parsed : null
}

/** Normalize PostgreSQL numeric strings at a load-response boundary before callers trust CanonicalLoad. */
export const normalizeLoadCoordinates = <T extends Partial<Record<LoadCoordinateKey, unknown>>>(
    load: T
): Omit<T, LoadCoordinateKey> & NormalizedLoadCoordinates => ({
    ...load,
    pickupLat: toFiniteNumberOrNull(load.pickupLat),
    pickupLon: toFiniteNumberOrNull(load.pickupLon),
    deliveryLat: toFiniteNumberOrNull(load.deliveryLat),
    deliveryLon: toFiniteNumberOrNull(load.deliveryLon),
})
